import React from 'react';

interface UserType {
  id: number;
  code: string;
  title: string;
  created_at: string;
  updated_at: string;
}

interface User {
  id: number;
  name: string;
  email: string;
  phone: string;
  profile_photo: string | null;
  user_type?: UserType | null;
}

interface Attendee {
  id: number;
  user_id: number;
  designation: string | null;
  user: User;
}
interface InfoAttendantsProps {
  attendees: Attendee[];
}

export default function InfoAttendants({ attendees }: InfoAttendantsProps) {
  return (
    <div className="bg-white p-4 border-l border-gray-200 ml-40">
      <h3 className="font-semibold text-blue-600 mb-4">Shift Attendants & Assistants ({attendees.length})</h3>

      {attendees.length > 0 ? (
        <div className="space-y-4">
          {attendees.map((person) => (
            <div key={person.id} className="flex items-center gap-3">
              <img
                src={person.user.profile_photo ?? `https://i.pravatar.cc/40?u=${person.user.email}`}
                alt={person.user.name}
                className="w-10 h-10 rounded-full"
              />
              <div>
                <p className="font-medium">{person.user.name}</p>
                <p className="text-sm text-gray-500">{person.user.user_type?.title ?? 'No Designation'}</p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-500">No attendants available.</p>
      )}
    </div>
  );
}
